import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import apiCall from "./../../API/API";
import PhoneInput from "react-phone-number-input";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";

const EditProfileSection = ({ user }) => {
  const [file, setFile] = useState(user?.profile_pic || "");
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState(user?.mobile || "");
  const [userid, setUserid] = useState(user?.uid || "");
  const [username, setUsername] = useState(user?.username || "");
  const initialJoining = user?.joining_date ? moment(user.joining_date).format("YYYY-MM-DD") : "";
  const [joiningDate, setJoiningDate] = useState(initialJoining);
  const [success, setSuccess] = useState("null");
  function delay(delayInms) {
    return new Promise((resolve) => setTimeout(resolve, delayInms));
  }
  const [errors, setErrors] = useState({});
  // console.log("user", user);

  const validateForm = () => {
    let newErrors = {};
    if (!userid) {
      newErrors.userid = "User id is required";
    }
    if (!username) {
      newErrors.username = "Username is required";
    }
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email is not valid";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (validateForm()) {
        // const body = {
        //   name: name,
        //   email: email,
        //   mobile: phone,
        // };

        let body = {};

        if (name && name !== user?.name) {
          body.name = name;
        }
        if (email && email !== user?.email) {
          body.email = email;
        }
        if (phone && phone !== user?.mobile) {
          body.mobile = phone;
        }
        if (joiningDate && joiningDate !== initialJoining) {
          body.joining_date = joiningDate;
        }

        if (Object.keys(body).length === 0) {
          toast.error("No changes to update");
          return;
        }
        const { data, error } = await apiCall(
          "POST",
          `/user-profile-update?uid=${userid}`,
          body,
          true
        );
        console.log(data, "....");
        if (data) {
          toast.success("Profile updated.");
          setSuccess("true");
          await delay(3000);
          setSuccess("null");
        } else {
          setSuccess("false");
          toast.error(error?.message || "Could not update the profile.");
          await delay(3000);
          setSuccess("null");
        }
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  return (
    <>
      <React.Fragment>
        <section className="formItems">
          <div className="uploadImage">
            <img src={file} alt="logo.png" />
            <div className="chooseFile">
              <label>
                <span>Upload Profile</span>
                <input
                  type="file"
                  onChange={(e) =>
                    setFile(URL.createObjectURL(e.target.files[0]))
                  }
                />
              </label>
            </div>
          </div>
          <div className="form">
            <Row>
              <Col lg="2"></Col>
              <Col lg="8">
                <form onSubmit={handleSubmit} className="registerForm">
                  <div>
                    <label>User Id</label>
                    <input type="number" value={userid} readOnly />
                  </div>
                  <div>
                    <label>Username</label>
                    <input type="text" value={username} readOnly />
                  </div>
                  <div>
                    <label>Full Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {errors.name == "" && (
                      <div className="formError">{errors.name}</div>
                    )}
                  </div>
                  <div>
                    <label>Email Address</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {errors.email == "" && (
                      <div className="formError">{errors.email}</div>
                    )}
                  </div>
                  <div>
                    <label>Joining Date</label>
                    <input
                      type="date"
                      value={joiningDate}
                      max={moment().format("YYYY-MM-DD")}
                      onChange={(e) => setJoiningDate(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Contact Number</label>

                    <PhoneInput
                      id="phoneInput"
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                      value={phone}
                      onChange={(value) => setPhone(value)} // Corrected line
                    />
                    {errors.phone && (
                      <div className="formError">{errors.phone}</div>
                    )}
                  </div>
                  <button onClick={handleSubmit} className="save">
                    Save
                  </button>
                  <a className="cancel">Cancel</a>
                </form>
              </Col>
            </Row>
          </div>
        </section>
        {/*<ToastContainer className="toast-container" />*/}
      </React.Fragment>
    </>
  );
};

export default EditProfileSection;
